import React from "react";
import { Grid } from "@mui/material";
import AppItem from "./AppItem";
import NewItem from "./NewItem";
import AppViewHeader from "./AppViewHeader";
import PropTypes from "prop-types";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { useKingsLink } from "../../hooks/kingsley";
import { useTranslation } from "react-i18next";
import KingsleyImage from "../../assets/images/Kingsley_Portal_Logo.png";

export default function AppView(props) {
  const {
    user,
    data,
    menuOptions,
    onMenuItemClick,
    onAddAppClick,
    appsContainerSize
  } = props;
  const { t } = useTranslation();
  const { kingsStatus, openKingsLink } = useKingsLink();
  if (kingsStatus === "loading") return <LoadingSpinner />;
  return (
    <>
      <AppViewHeader
        onAddAppClick={onAddAppClick}
        showAddButton={user && user.isAdmin}
      />
      <Grid data-qa="learning-center-app-view" container spacing={3}>
        {kingsStatus === "Success" && (
          <Grid item {...appsContainerSize}>
            <AppItem
              data={{
                img: KingsleyImage,
                title: t("KingsleyPortal"),
                permanent: true
              }}
              menuOptions={menuOptions}
              onMenuItemClick={onMenuItemClick}
              user={user}
              openApp={openKingsLink}
            />
          </Grid>
        )}
        {data.map((appItem, index) => (
          <Grid item {...appsContainerSize} key={index}>
            <AppItem
              data={appItem}
              menuOptions={menuOptions}
              onMenuItemClick={onMenuItemClick}
              user={user}
            />
          </Grid>
        ))}
        {user && user.isAdmin && (
          <Grid item {...appsContainerSize} key={"addapp"}>
            <NewItem onAddAppClick={onAddAppClick} />
          </Grid>
        )}
      </Grid>
    </>
  );
}

AppView.propTypes = {
  user: PropTypes.object,
  data: PropTypes.arrayOf(PropTypes.object),
  menuOptions: PropTypes.arrayOf(PropTypes.object),
  onMenuItemClick: PropTypes.func,
  onAddAppClick: PropTypes.func,
  appsContainerSize: PropTypes.object
};
